import { Checkbox, FormControlLabel, Modal } from '@mui/material';
import {
	CancelBtn,
	ConfirmBtn,
} from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/Pages/Webinar/Pages/RegisteredUsers/Components/ChangeUserSlotModule';
import { studentsGetSingle } from '@Pages/Students/Slice/Students.Slice';
import { useSnackbar } from '@Providers/useSnackbar';
import { addToWalletRequest } from '@Services/students/students.req';
import { FlexLayout } from '@Styled/utilities';
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Container, Header } from './SetModel';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

type Props = {
	handleModelClose: React.Dispatch<boolean>;
	openModel: boolean;
	walletAmount: string | number;
	id: string;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
	setDisplayedAmount: React.Dispatch<React.SetStateAction<number>>;
	setWalletAmount: React.Dispatch<React.SetStateAction<string | number>>;
	setError: React.Dispatch<React.SetStateAction<string>>;
};

const AddModel: React.FC<Props> = ({
	handleModelClose,
	openModel,
	walletAmount,
	id,
	setLoading,
	setDisplayedAmount,
	setWalletAmount,
	setError,
}) => {
	const { displaySnackbar } = useSnackbar();
	const dispatch = useDispatch();

	const [type, setType] = useState<string>('');
	const _addToWallet = useCallback(async () => {
		if (!walletAmount) return displaySnackbar('error', 'Amount is required!');
		try {
			setLoading(true);
			await addToWalletRequest(id, Number(walletAmount), '', type);
			setDisplayedAmount((prev) => prev + Number(walletAmount));
			setWalletAmount(0);
			setError('');
			setLoading(false);
			displaySnackbar('success', 'Addedd successfully');
			handleModelClose(false);
			dispatch(studentsGetSingle({ id }));
		} catch (error) {
			const msg =
				error.response?.data.message ||
				"there's a problem updating the amount, please try again!";

			displaySnackbar('error', msg);
		}
	}, [walletAmount, id, displaySnackbar, dispatch, type]);

	return (
		<Modal
			open={openModel}
			onClose={() => {
				handleModelClose(false);
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Container>
				<Header>Are you sure you want to..?</Header>
				<FlexLayout flexDirection="column" marginTop="20px" marginBottom="20px">
					<FormControlLabel
						control={
							<Checkbox
								checked={type === 'refundable'}
								onClick={() => setType('refundable')}
								icon={<RadioButtonUncheckedIcon />}
								checkedIcon={<RadioButtonCheckedIcon />}
							/>
						}
						label="Add to refundable amount"
					/>
					<FormControlLabel
						control={
							<CheckboxStyle
								checked={type === 'nonrefundable'}
								onClick={() => setType('nonrefundable')}
								icon={<RadioButtonUncheckedIcon />}
								checkedIcon={<RadioButtonCheckedIcon />}
							/>
						}
						label="Add to non refundable amount"
					/>
				</FlexLayout>
				<FlexLayout justifyContent="flex-end" gridGap="1rem">
					<CancelBtn
						variant="text"
						color="warning"
						onClick={() => {
							handleModelClose(false);
						}}
					>
						NO
					</CancelBtn>
					<ConfirmBtn
						variant="text"
						color="inherit"
						type="submit"
						onClick={() => {
							_addToWallet();
						}}
					>
						YES
					</ConfirmBtn>
				</FlexLayout>
			</Container>
		</Modal>
	);
};

export const CheckboxStyle = styled(Checkbox)``;

export default AddModel;
